import { format, isValid, parseISO } from 'date-fns';

const prepareDateFnsFormat = (formatStr: string): string => {
  return formatStr.replace(/DD/g, 'dd').replace(/YYYY/g, 'yyyy');
};

/**
 * Format the given ISO date to a specified format.
 *
 * @param {string} date - The input ISO date string in local time zone (e.g., '2024-08-20T09:56:59.287').
 * @param {string} formatStr - The desired output date format (e.g., 'MM/dd/yyyy h:mm:ss a').
 * @returns {string} - The formatted date as a string.
 */
export const formatDate = (date: string, formatStr: string): string => {
  if (!date) {
    return '';
  }

  if (!formatStr) {
    return date;
  }

  const parsedDate = parseISO(date?.replace('Z', ''));
  if (!isValid(parsedDate)) {
    return '';
  }

  const outputFormat = prepareDateFnsFormat(formatStr);

  return format(parsedDate, outputFormat);
};

export const WEEKDAY_FULL_DATETIME_FORMAT = 'EEEE MMMM dd, yyyy hh:mm a'; // Tuesday November 25, 2025 08:22 AM
export const ISO_DATETIME_NO_TZ_FORMAT = "yyyy-MM-dd'T'HH:mm:ss"; // 2026-03-30T12:00:00
